export interface DisplayColorInput {
  colors: ReadonlyArray<{ id: string; hex: string }>;
  selectedColors: ReadonlyArray<string>;
  focusedColorId: string | null;
  isFocused: boolean;
}

/**
 * Which color a product card shows: the focused color on the focused card,
 * otherwise the most recently selected color, otherwise the product's first
 * color. White is only the last resort for products without colors.
 */
export function resolveDisplayColor(input: DisplayColorInput): {
  id: string | null;
  hex: string;
} {
  const byId = new Map(input.colors.map((c) => [c.id, c]));
  if (input.isFocused && input.focusedColorId) {
    const focused = byId.get(input.focusedColorId);
    if (focused) return { id: focused.id, hex: focused.hex };
  }
  for (let i = input.selectedColors.length - 1; i >= 0; i -= 1) {
    const colorId = input.selectedColors[i];
    if (colorId === undefined) continue;
    const selected = byId.get(colorId);
    if (selected) return { id: selected.id, hex: selected.hex };
  }
  const first = input.colors[0];
  return first
    ? { id: first.id, hex: first.hex }
    : { id: null, hex: '#FFFFFF' };
}
